import styled, { keyframes } from 'styled-components'

const slideIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.95);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`
export const SliderContainer = styled.div`
  margin: auto;
  padding: 2rem 0.2rem;
  height: 100vh;
  background: white;
  text-align: center;
  align-content: center;
`
export const Subtitle = styled.p`
  color: #030852;
  text-align: center;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 700;

  &::before,
  &::after {
    content: '-';
    margin: 0 1rem;
    color: #030852;
  }
  @media screen and (max-width: 515px) {
    font-size: 1rem;
  }
`

export const SlideImage = styled.img`
  width: 100%;
  height: 400px;
  border-radius: 12px;
  animation: ${slideIn} 0.6s ease forwards;
`

export const SlideWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 1rem;
`
